import React from 'react'
import { BrowserRouter, Route, Switch } from 'react-router-dom'

import SearchResults from '../SearchResults/SearchResults'

import './DevApp.css'

const DevApp = () => (
  <BrowserRouter basename='/'>
    <div styleName='wrapper'>
      <h1>DEV</h1>
      <Switch>
        <Route component={SearchResults} exact path='/' />
        <Route render={() => <h2>Route not found</h2>} />
      </Switch>
    </div>
  </BrowserRouter>
)

export default DevApp
